<template>
    <div class="mlb">

       <van-row type="flex" justify="center" style="width:85%;margin:auto">
           <img src='@/assets/ic1.png'/>
           <div class="right">
                <van-swipe
                    vertical
                    class="notice-swipe"
                    :autoplay="3000"
                    :show-indicators="false"
                >
                    <van-swipe-item v-for="(item, index) in data" :key="index">大单：{{item.orderNum}} 金额：{{item.money}} 导购：{{item.guideName}}</van-swipe-item>
                    <!-- <van-swipe-item>内容 2</van-swipe-item>
                    <van-swipe-item>内容 3</van-swipe-item> -->
                </van-swipe>
               <!-- 大单:sssss11111 -->
           </div>
       </van-row>
    </div>
</template>
<script>
export default {
     props:{
        data:{
            type:Array,
            default:[{orderNum:"",money:"",guideName:""}]
        }
    },
}
</script>
<style lang="scss" scoped>
.device_pc{
 .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
   img{
       width:42px;      
       height: 34px;
       margin-right: 10px;
       margin-top: -10px;
   }
   .right{
       color: #eacd2c;
       flex:1;
       display: flex;
       align-items: center;
       font-size: 18px;
      
   }
}
 .device_phone{
 .notice-swipe {
    height: 80px;
    line-height: 80px;
  }
   img{
       width:84px;      
       height: 68px;
       margin-right: 10px;
       margin-top: -10px;
   }
   .right{
       color: #eacd2c;
       flex:1;
       display: flex;
       align-items: center;
       font-size: 18px;
      
   }
}
</style>